<template>
  <div class="row">
    <div class="col-12">
      <div class="col-12 p-2 d-flex align-items-center mt-4">
        <div class="w-100 pt-0 ">
          <div class="title-divider" />
        </div>
        <div class="col-auto title-content py-1 text-center mx-3">
          <div>
            <span>Listado de Estudiantes Egresados con Impedimentos</span>
          </div>
        </div>
        <div class="w-100 pt-0 ">
          <div class="title-divider w-100" />
        </div>
      </div>

      <div
        v-if="results.length === 0"
        class="col-12 p-4 text-center align-items-center no-info mt-4"
      >
        <div class="row justify-content-center">
          <div class="col-12 col-lg-1 align-self-center">
            <i class="far fa-folder-open icon no-info-icon pl-2" />
          </div>
          <div class="col-12 col-lg-3 ml-lg-n4 align-self-center">
            <span class="no-info-text">No hay información disponible.</span>
          </div>
        </div>
      </div>

      <div v-if="results.length !== 0">
        <div
          v-for="item in results"
          :key="item.studentExitId"
          :class="
            'col-md-12 col-sm-12 egress-interview mt-4 p-3 ' +
              getPeiStatusClass(item.status)
          "
        >
          <div class="row">
            <div class="col col-sm col-12 mt-2 border-right pt-2 ">
              <span
                :class="
                  'text-center py-1 px-3 badge ' +
                    getPeiStatusClass(item.status)
                "
              >
                {{ item.status }}
              </span>
            </div>
            <div class="col col-sm col-12 pt-2">
              <span class="data-title">
                Nombre:
                <br />
              </span>
              <span class="data-content">{{ item.studentFullName }}</span>
            </div>
            <div class="col col-sm col-12 pt-2">
              <span class="data-title">
                SIE:
                <br />
              </span>
              <span class="data-content">{{ item.studentSieId }}</span>
            </div>
            <div class="col col-sm col-12 pt-2">
              <span class="data-title">
                Razón de Egreso:
                <br />
              </span>
              <span class="data-content">{{ item.studentExitType }}</span>
            </div>
            <div class="col col-sm col-12 pt-2">
              <div class="dropdown text-right">
                <button
                  class="btn btn-dropdown-actions dropdown-toggle pt-1"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Acciones
                </button>
                <div class="dropdown-menu dropdown-menu-right pb-0 mt-1">
                  <a
                    v-if="item.status === questionnaireStatus.Submitted"
                    class="drop-item cursor-pointer"
                    @click="downloadReferralReport(item.studentExitId)"
                  >
                    <em class="fas fa-download text-green pr-1" />
                    <span>Imprimir Cuestionario</span>
                  </a>
                  <div
                    v-if="item.status === questionnaireStatus.Submitted"
                    class="dropdown-action-divider "
                  />
                  <a
                    class="drop-item cursor-pointer "
                    @click="
                      $router.push({
                        name: 'EgressQuestionnaire',
                        params: { studentExitId: item.studentExitId },
                      })
                    "
                  >
                    <div v-if="item.status !== questionnaireStatus.Submitted">
                      <em class="fas fa-edit text-green pr-1" />
                      <span>Editar</span>
                    </div>
                    <div v-if="item.status === questionnaireStatus.Submitted">
                      <i class="fas fa-eye text-green pr-1" />
                      <span>Ver</span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Pagination
          id="historyPager"
          :show-text="true"
          :data="pagination"
          @pagination-go-page="goToPage"
        />
      </div>
    </div>
  </div>
</template>

<script>
import generalService from '@/services/pei/general';
import questionnaireStatusEnum from '@/utils/constants/student-follow-up/questionnaireStatus';
import Pagination from '@/components/common/Pagination';

export default {
  name: 'GraduateInterview',
  components: {
    Pagination,
  },
  props: {
    results: {
      type: Array,
      default: () => [],
    },
    pagination: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      questionnaireStatus: questionnaireStatusEnum,
    };
  },
  methods: {
    getPeiStatusClass(status) {
      let statusClass = '';
      //ECG:Esto se debe basar en id de estatus de pei
      switch (status) {
        case 'No Entrevistado':
          statusClass = 'no-interview';
          break;
        case 'Cuestionario Sometido':
          statusClass = 'completed';
          break;
        case 'En Proceso':
          statusClass = 'no-interview';
          break;
      }

      return statusClass;
    },
    goToPage(page) {
      this.$emit('GoToHandler', page);
    },
    async downloadReferralReport(studentExitId) {
      let self = this;
      let promise = new Promise((resolve) => {
        self
          .$ApiGet(`/api/studentexit/${studentExitId}/PreSchoolStudentReport`)
          .then((res) => {
            self.report = res.data;
            generalService.documentDownloadReport(
              self.report.content,
              self.report.filename
            );
            resolve(res.data);
          })
          .catch((err) => {
            self.response = err;
          });
      });
      return promise;
    },
  },
};
</script>

<style scoped>
.badge.no-interview {
  height: 32px;
  background: #f8eb7f 0% 0% no-repeat padding-box;
  border-radius: 18px;
  opacity: 1;
  text-align: center;
  font: Bold 16px/21px Lato;
  letter-spacing: 0;
  color: #11291b;
}
.badge.completed {
  height: 32px;
  background: #a3e5b3 0% 0% no-repeat padding-box;
  border-radius: 18px;
  opacity: 1;
  text-align: center;
  font: Bold 16px/21px Lato;
  letter-spacing: 0;
  color: #11291b;
}
.btn-setting {
  background: #ff7058 0% 0% no-repeat padding-box;
  border-radius: 4px;
  border: 0px !important;
  color: #ffffff;
  opacity: 1;
}
.btn-setting-off {
  background-color: #f4f6f3;
  border-radius: 4px;
  border: 0px !important;
  color: #3f5b60;
}

.search-bar {
  background: #f4f6f3 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
}

.title-divider {
  border: 1px solid #b5c3bc;

  opacity: 1;
}
.title-content {
  background: #3f5b60 0% 0% no-repeat padding-box;
  border-radius: 21px;
  opacity: 1;
  text-align: center;
  font: Bold 17px/23px Lato;
  letter-spacing: 0;
  color: #ffffff;
}
.filter-content {
  font: Bold 14px/17px Lato;
  letter-spacing: 0;
  color: #aab7b1;
  opacity: 1;
}

.no-info {
  background: #f7f7f7 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
  border-left-style: solid;
  border-color: #e8e8e8;
  border-width: 0;
}
.no-info-text {
  text-align: left;
  font: Bold 16px/22px Lato;
  letter-spacing: 0;
  color: #727272;
  opacity: 1;
}
.no-info-icon {
  color: #727272;
  font-size: 32px;
}

.interview-status {
  height: 32px;
  background: #f8eb7f 0% 0% no-repeat padding-box;
  border-radius: 18px;
  opacity: 1;
  text-align: center;
  font: Bold 16px/21px Lato;
  letter-spacing: 0;
  color: #11291b;
}
.egress-interview {
  background: #f7f7f7 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;

  border-left-style: solid;
  border-color: #f8eb7f;
  border-width: 4px;
}

.btn-dropdown-actions {
  text-align: center;
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 1rem;
  color: rgb(12, 19, 16);
  border-radius: 4px;
  margin-right: 0px;
  border: 1px solid #2db782;
}
.dropdown-menu {
  margin-top: 1rem;
}

.dropdown-item {
  font: Regular 16px/19px Lato;
}

.dropdown-item i {
  margin-right: 1rem;
}

.drop-item {
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 0.9375rem;
  color: #11291b;
  text-align: inherit;
  white-space: nowrap;
  display: block;
  padding: 0.29rem 1.5rem;
  clear: both;
}

.dropdown-action-divider {
  border-top-width: 1px;
  border-top-style: solid;
  border-color: #e2e2e2;
  margin-left: 5%;
  margin-right: 5%;
}

.settings-button {
  align-content: center;

  background: #ff7058 0% 0% no-repeat padding-box;
  border-radius: 4px;
  opacity: 1;
}

.icon {
  font-size: 35px;
  height: 60px;
  width: 60px;
  border: solid 3px;
  border-radius: 127px;
  padding-top: 8px;
  padding-right: 4px;
  color: #e2e2e2;
}

.egress-interview.no-interview {
  border-color: #f8eb7f;
}

.egress-interview.completed {
  border-color: #a3e5b3;
}

.egress-interview.in-process {
  border-color: #d5b89a;
}
</style>
<style>
.was-Invalidated {
  top: 22px !important;
}
.student-search-alert-error.no-border {
  top: 22px !important;
  padding-bottom: 1px;
}

@media (min-width: 1440px) {
  .was-Invalidated {
    top: 10px !important;
  }
  .student-search-alert-error.no-border {
    top: 10px !important;
    padding-bottom: 1px;
  }
}
</style>
